<ion-header>

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title>
      <div translate>ADD_LEADER.TITLE</div>
    </ion-title>
  </ion-toolbar>

</ion-header>

<ion-content class="ion-padding" no-bounce>
  <ng-template [ngIf]="isLoading">
    <div class="v-box full-width full-height justify-around align-center">
      <ion-spinner color="dark"></ion-spinner>
    </div>
  </ng-template>

  <ng-template [ngIf]="!isLoading && !hasLeader">
    <p translate>ADD_LEADER.ERROR</p>
    <p class="leader">{{leaderName}}</p>
  </ng-template>

  <ng-template [ngIf]="!isLoading && hasLeader">
    <p translate>ADD_LEADER.QUESTION</p>
    <p class="leader">{{leaderName}}</p>
  </ng-template>
</ion-content>

<ion-footer *ngIf="!isLoading">
  <ion-grid>
    <ion-row *ngIf="!hasLeader">
      <ion-col size="12">
        <ion-button fill="fill" expand="block" color="light" shape="round" class="full-width" (click)="onCancelClick()">
          <div translate>COMMON.BACK</div>
        </ion-button>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="hasLeader" class="not-first-button-line">
      <ion-col size="6">
        <ion-button fill="fill" expand="block" color="light" shape="round" class="half-width" (click)="onCancelClick()">
          <div translate>COMMON.CANCEL</div>
        </ion-button>
      </ion-col>
      <ion-col size="6">
        <ion-button fill="fill" expand="block" color="light" shape="round" class="half-width" (click)="onAcceptClick()">
          <div translate>COMMON.APPLY</div>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>

